import AchForm from "../../components/deposit/ach-form";
import { connect } from "react-redux";
import CreditCardForm from "../../components/deposit/credit-card-form";
import { deleteCreditCard, depositAch, depositNewCreditCard, depositSavedCreditCard, setDepositCreditCard, setDepositPaymentMethod } from "../../actions/deposit";
import DepositTransactionSummary from "../../components/deposit-transaction-summary";
import { getCommunications, getDeposit, getSession } from "../../selectors";
import React from "react";
import requireAuthentication from "../../components/higher-order/require-authentication";
import Step from "../../components/step";
import Steps from "../../components/steps";
import { withRouter } from "react-router-dom";

class DepositMethodPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.setMethod = this.setMethod.bind(this);

    var { deposit, history } = props;
    if (!deposit.get("amount") || deposit.get("confirmed")) {
      history.push("/deposit");
    }
  }

  setMethod(e) {
    var { setDepositPaymentMethod: onSetDepositPaymentMethod } = this.props;
    onSetDepositPaymentMethod(e.target.value);
  }

  getDefaultDepositMethod() {
    return "credit_card";
  }

  render() {
    var {
      communications,
      deleteCreditCard: dcc,
      deposit,
      depositAch: da,
      depositNewCreditCard: dncc,
      depositSavedCreditCard: dscc,
      history,
      session,
      setDepositCreditCard: sdcc
    } = this.props;

    var amount = deposit.get("amount");
    var method = deposit.get("paymentMethod") || this.getDefaultDepositMethod();

    var form;
    if (method === "credit_card") {
      form = (
        <CreditCardForm
          communications={communications}
          deposit={deposit}
          history={history}
          onDeleteCreditCard={dcc}
          onDepositNewCreditCard={dncc}
          onDepositSavedCreditCard={dscc}
          session={session}
          setDepositCreditCard={sdcc} />);
    } else if (method === "ach") {
      form = <AchForm communications={communications} deposit={deposit} history={history} onSubmit={da} session={session} />;
    }

    var methods = [];
    if (session.getIn(["deposit_methods", "credit_card"])) {
      methods.push(
        <label className="label--radio margin-bottom--is-0" data-target="panel-credit-card" htmlFor="radio-credit-card" key="credit_card">
          <input checked={method === "credit_card"} className="vertical-align--is-middle margin-bottom--is-10" id="radio-credit-card" name="payment-options" onChange={this.setMethod} type="radio" value="credit_card" />

          <span className="font-family--is-heading text-24--desktop text--is-bold vertical-align--is-middle">
            Credit Card
          </span>
        </label>
      );
    }
    if (session.getIn(["deposit_methods", "ach"])) {
      methods.push(
        <label className="label--radio margin-bottom--is-0" data-target="panel-ach" htmlFor="radio-ach" key="ach">
          <input checked={method === "ach"} className="vertical-align--is-middle margin-bottom--is-10" id="radio-ach" name="payment-options" onChange={this.setMethod} type="radio" value="ach" />

          <span className="font-family--is-heading text-24--desktop text--is-bold vertical-align--is-middle">
            ACH
          </span>
        </label>
      );
    }

    return (
      <div className="l-wrapper">
        <div className="l-content l-content--80-percent">

          <Steps>
            <Step>
              Deposit Amount
            </Step>

            <Step>
              Billing Information
            </Step>

            <Step selected>
              Payment Method
            </Step>

            <Step>
              Deposit Confirmation
            </Step>
          </Steps>

          <h1 className="text-center">
            Now Select A Payment Method
          </h1>

          <div className="batch-g batch-g--padding">
            <DepositTransactionSummary amount={amount} />

            <div className="batch-c-1-1 batch-c-md-2-3 batch-c-order-md-1">
              <div className="form--is-horizontal">
                <div className="batch-g batch-g--padding batch-g--valign-center">

                  <div className="batch-c-1-1 batch-c-md-1-4">
                    <label htmlFor="address">
                      Payment Options
                    </label>
                  </div>

                  <div className="batch-c-1-1 batch-c-md-3-4">
                    {methods}
                  </div>
                </div>

                {form}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function select(state) {
  return {
    communications: getCommunications(state),
    deposit: getDeposit(state),
    session: getSession(state)
  };
}

export default connect(select, {
  deleteCreditCard,
  depositAch,
  depositNewCreditCard,
  depositSavedCreditCard,
  setDepositCreditCard,
  setDepositPaymentMethod
})(requireAuthentication(withRouter(DepositMethodPage)));
